export const CASE_SECTION_HEADING = {
  extraHeading: 'CASE',
  mainHeading: '導入事例',
}
